import { ReadyState } from '../match3.redux';
import { animate, ImageView, View } from '@play-co/timestep-core/ui';
import { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import { animDuration } from 'src/lib/utils';
import uiConfig from 'src/lib/ui/config';
import { createEmitter } from 'src/lib/Emitter';
import { height } from 'src/lib/ui/config/general';

export class ReadyStateOverlay {
  readonly view: View;
  private currentState: ReadyState;
  private readyMessage: ImageView;

  constructor(opts: ViewOpts) {
    this.view = new View({
      ...opts,
      zIndex: height,
    });

    this.readyMessage = this.view.addSubview(
      new ImageView({
        width: 720,
        height: 329,
        scale: 0,
      }),
    );

    createEmitter(this.view, ({ match3 }) => match3.readyState).addListener(
      (readyState) => {
        void this.setReadyState(readyState);
      },
    );
  }

  async setReadyState(state: ReadyState) {
    if (this.currentState === state) {
      return;
    }

    this.currentState = state;

    const { width, height } = this.readyMessage.style;
    await animate(this.readyMessage)
      .now(
        {
          scale: 0,
          offsetX: width / 2,
          offsetY: height / 2,
        },
        animDuration,
      )
      .toPromise();

    if (state === 'hidden') {
      this.view.hide();
      return;
    }

    this.view.show();
    switch (state) {
      case 'ready': {
        this.view.updateOpts({
          backgroundColor: uiConfig.popups.backgroundDarker.backgroundColor,
        });
        this.readyMessage.setImage('assets/minigame/match3/ready_en.png');
        break;
      }
      case 'go': {
        this.view.updateOpts({
          backgroundColor: uiConfig.popups.background.backgroundColor,
        });
        this.readyMessage.setImage('assets/minigame/match3/go_en.png');
        break;
      }
      case 'finish': {
        this.view.updateOpts({
          backgroundColor: uiConfig.popups.backgroundDarker.backgroundColor,
        });
        this.readyMessage.setImage('assets/minigame/match3/finish_en.png');
        break;
      }
    }

    await animate(this.readyMessage)
      .now(
        {
          scale: 1,
          offsetX: 0,
          offsetY: 0,
        },
        animDuration,
      )
      .toPromise();
  }

  layout() {
    const { height } = this.view.style;
    this.readyMessage.style.y = height / 2 - 200;
  }
}
